import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CrudPage from './shared/CrudPage';
import {
  getCategorias, createCategoria, updateCategoria, deleteCategoria,
  getLenguajes, uploadAdminFile,
} from '../../api/adminClient';

export default function AdminCategorias() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [lenguajeOpts, setLenguajeOpts] = useState([]);
  const [langFilter, setLangFilter] = useState(searchParams.get('lenguajeId') ?? '');

  useEffect(() => {
    getLenguajes().then((rows) =>
      setLenguajeOpts(rows.map((l) => ({ value: l.ID, label: l.Descripcion })))
    ).catch(() => {});
  }, []);

  return (
    <CrudPage
      title="Procesos (TipoTest)"
      idKey="ID"
      columns={[
        { key: 'ID', label: 'ID' },
        {
          key: 'rutaImagen',
          label: 'Icono',
          render: (v) => v
            ? <img src={v} alt="icono" className="w-9 h-9 rounded-lg object-cover border border-slate-200" />
            : <span className="text-slate-300 text-xs">—</span>,
        },
        {
          key: 'Descripcion',
          label: 'Descripción',
          primary: true,
          render: (v, row) => (
            <div>
              <button
                type="button"
                onClick={() => navigate(`/admin/tareas?categoriaId=${row.ID}`)}
                className="text-left font-semibold text-violet-700 hover:text-violet-900 hover:underline bg-transparent border-0 cursor-pointer p-0"
              >
                {v}
              </button>
              <div className="font-normal text-xs text-slate-400 mt-0.5">{row.lenguaje}</div>
            </div>
          ),
        },
        {
          key: 'total_tareas',
          label: 'Tareas',
          render: (v) => (
            <span className="inline-flex items-center justify-center min-w-[1.5rem] px-1.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-600">
              {v ?? 0}
            </span>
          ),
        },
        { key: 'baja', label: 'Baja', render: (v) => v ? 'Sí' : 'No' },
      ]}
      fields={[
        { key: 'id_lenguaje', label: 'Acceso', type: 'select', options: lenguajeOpts, required: true },
        { key: 'Descripcion', label: 'Descripción', required: true },
        { key: 'marcoteorico', label: 'Marco teórico', type: 'textarea' },
        { key: 'observaciones', label: 'Observaciones', type: 'textarea' },
        {
          key: 'rutaImagen',
          label: 'Icono',
          type: 'image',
          onUpload: (file) => uploadAdminFile(file, 'categorias'),
        },
        { key: 'baja', label: 'Baja', type: 'checkbox' },
      ]}
      fetchAll={getCategorias}
      onCreate={createCategoria}
      onUpdate={updateCategoria}
      onDelete={deleteCategoria}
      actions={[
        { label: 'Ver tareas', onClick: (row) => navigate(`/admin/tareas?categoriaId=${row.ID}`) },
      ]}
      filterFn={langFilter ? (row) => String(row.id_lenguaje) === langFilter : null}
      toolbar={
        <select
          value={langFilter}
          onChange={(e) => {
              setLangFilter(e.target.value);
              setSearchParams(e.target.value ? { lenguajeId: e.target.value } : {});
            }}
          className="rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:border-violet-500"
        >
          <option value="">Ver todos</option>
          {lenguajeOpts.map((o) => (
            <option key={o.value} value={String(o.value)}>{o.label}</option>
          ))}
        </select>
      }
    />
  );
}
